"use client";
import { CoworldReplayFrame } from "../frame/coworld-replay-frame";
import { ReplayViewerView, type ReplayViewerProps } from "./replay-viewer-view";

export function ReplayViewer(props: ReplayViewerProps) {
  const { coworldId, replayUrl, coworldTelemetryContext } = props;
  const renderCoworldFrame =
    coworldId && replayUrl && coworldTelemetryContext
      ? (height: string) => (
          <CoworldReplayFrame
            coworldId={coworldId}
            replayUri={replayUrl}
            telemetryContext={coworldTelemetryContext}
            surface={props.coworldSurface ?? "episode_detail"}
            achievement={props.achievement}
            height={height}
            minHeight="240px"
          />
        )
      : () => null;
  return (
    <ReplayViewerView {...props} renderCoworldFrame={renderCoworldFrame} />
  );
}
